import { CheckCircle2, ChefHat, Clock, XCircle } from "lucide-react";
import type { OrderStatus } from "@/types";

export interface StatusMeta {
  label: string;
  icon: React.ElementType;
  color: string;
  bg: string;
}

export const statusConfig: Record<OrderStatus, StatusMeta> = {
  pending: {
    label: "Pending",
    icon: Clock,
    color: "text-amber-600",
    bg: "bg-amber-50 border-amber-200",
  },
  preparing: {
    label: "Preparing",
    icon: ChefHat,
    color: "text-blue-600",
    bg: "bg-blue-50 border-blue-200",
  },
  ready: {
    label: "Ready",
    icon: CheckCircle2,
    color: "text-green-600",
    bg: "bg-green-50 border-green-200",
  },
  completed: {
    label: "Completed",
    icon: CheckCircle2,
    color: "text-gray-600",
    bg: "bg-gray-50 border-gray-200",
  },
  cancelled: {
    label: "Cancelled",
    icon: XCircle,
    color: "text-red-600",
    bg: "bg-red-50 border-red-200",
  },
};
